/**
 * React Query hooks for Position Thesis operations.
 */

import { useQuery } from '@tanstack/react-query';
import { getPositionTheses, type PositionThesis } from '../positionThesisApi';

/**
 * Hook to fetch all thesis versions for a position.
 *
 * @param positionId - Position ID to fetch theses for
 * @param enabled - Whether to enable query (default: true)
 */
export function usePositionTheses(positionId: number | null, enabled: boolean = true) {
  return useQuery<PositionThesis[]>({
    queryKey: ['positionThesis', positionId],
    queryFn: () => getPositionTheses(positionId!),
    enabled: enabled && !!positionId,
    staleTime: 2 * 60 * 1000, // Consider data fresh for 2 minutes
  });
}
